// extracted by mini-css-extract-plugin
export default {"rowCards":"JobOpportunitiesView_rowCards__YdKwN"};